import { InMemoryHeader, InMemoryString } from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";

export default [
  new InMemoryHeader({
    title: "Identifier",
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Translations[]"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Name", {
      getString: (item) => translate2(item, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.order",
    type: new InMemoryString("Order"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
    orderByKey: "Order",
  }),
  new InMemoryHeader({
    title: "globals.description",
    type: new InMemoryString("Description", {
      getString: (item) => translate2(item, "Description"),
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.kind",
    type: new InMemoryString("Kind", {
      getString: (item) => translate2(item, "Kind"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  // new InMemoryHeader({
  //     type: new InMemoryString("CoverageIdentities[]/Translations[]/LanguageCode"),
  //     sortable: false,
  //     visible: false,
  //     allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //     title: "globals.coverage",
  //     type: new InMemoryString("CoverageIdentities[]/Translations[]/Name", {
  //         getString: (item) => {return item.CoverageIdentities.map(o=>translate2(o, "Name")).join(", ")},
  //         getHtml: (item, type) => {
  //             return ("<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
  //                 type.getString(item, type) +
  //                 "</div>");
  //         }
  //       }),
  //     sortable: false,
  //     visible: true,
  //     searchable: true
  // }),
  new InMemoryHeader({
    title: "globals.coverage",
    type: new InMemoryString(
      "CoverageIdentities[]/Current/Translations[]/Name",
      {
        getString: (item) => {
          return item.CoverageIdentities.map(
            (o) =>
              translate2(o.Current, "Name") +
              " (" +
              translate2(o.Current, "Description") +
              ")"
          ).join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }
    ),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.employers",
    type: new InMemoryString(
      "Employers[]/Translations[]/Name",
      {
        getString: (item) => {
          if (item.Employers && item.Employers.length > 0) {
            return item.Employers.map(
              (o) =>
                translate2(o, "Name")
            ).join(", ");
          }
          return "";
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }
    ),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  // new InMemoryHeader({
  //     type: new InMemoryString("CoverageIdentities[]/Name"),
  //     visible: false,
  //     allowVisibilityChange: false
  // })
];
